import { EventEmitter, Directive, ElementRef, Input, Output, NgModule } from '@angular/core';

// playground: stackblitz.com/edit/countup-typescript
import * as ɵngcc0 from '@angular/core';
class CountUp {
    constructor(target, endVal, options) {
        this.target = target;
        this.endVal = endVal;
        this.options = options;
        // public version = '2.0.0';
        this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: true,
            useGrouping: true,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ',',
            decimal: '.',
            prefix: '',
            suffix: ''
        };
        this.finalEndVal = null; // for smart easing
        this.useEasing = true;
        this.countDown = false;
        this.error = '';
        this.startVal = 0;
        this.paused = true;
        this.count = (timestamp) => {
            if (!this.startTime) {
                this.startTime = timestamp;
            }
            const progress = timestamp - this.startTime;
            this.remaining = this.duration - progress;
            // to ease or not to ease
            if (this.useEasing) {
                if (this.countDown) {
                    this.frameVal = this.startVal - this.easingFn(progress, 0, this.startVal - this.endVal, this.duration);
                }
                else {
                    this.frameVal = this.easingFn(progress, this.startVal, this.endVal - this.startVal, this.duration);
                }
            }
            else {
                if (this.countDown) {
                    this.frameVal = this.startVal - ((this.startVal - this.endVal) * (progress / this.duration));
                }
                else {
                    this.frameVal = this.startVal + (this.endVal - this.startVal) * (progress / this.duration);
                }
            }
            // don't go past endVal since progress can exceed duration in the last frame
            if (this.countDown) {
                this.frameVal = (this.frameVal < this.endVal) ? this.endVal : this.frameVal;
            }
            else {
                this.frameVal = (this.frameVal > this.endVal) ? this.endVal : this.frameVal;
            }
            // decimal
            this.frameVal = Math.round(this.frameVal * this.decimalMult) / this.decimalMult;
            // format and print value
            this.printValue(this.frameVal);
            // whether to continue
            if (progress < this.duration) {
                this.rAF = requestAnimationFrame(this.count);
            }
            else if (this.finalEndVal !== null) {
                // smart easing
                this.update(this.finalEndVal);
            }
            else {
                if (this.callback) {
                    this.callback();
                }
            }
        };
        // default format and easing functions
        this.formatNumber = (num) => {
            const neg = (num < 0) ? '-' : '';
            let result;
            let x;
            let x1;
            let x2;
            let x3;
            result = Math.abs(num).toFixed(this.options.decimalPlaces);
            result += '';
            x = result.split('.');
            x1 = x[0];
            x2 = x.length > 1 ? this.options.decimal + x[1] : '';
            if (this.options.useGrouping) {
                x3 = '';
                for (let i = 0, len = x1.length; i < len; ++i) {
                    if (i !== 0 && (i % 3) === 0) {
                        x3 = this.options.separator + x3;
                    }
                    x3 = x1[len - i - 1] + x3;
                }
                x1 = x3;
            }
            // optional numeral substitution
            if (this.options.numerals && this.options.numerals.length) {
                x1 = x1.replace(/[0-9]/g, (w) => this.options.numerals[+w]);
                x2 = x2.replace(/[0-9]/g, (w) => this.options.numerals[+w]);
            }
            return neg + this.options.prefix + x1 + x2 + this.options.suffix;
        };
        this.easeOutExpo = (t, b, c, d) => c * (-Math.pow(2, -10 * t / d) + 1) * 1024 / 1023 + b;
        this.options = Object.assign(Object.assign({}, this.defaults), options);
        this.formattingFn = (this.options.formattingFn) ?
            this.options.formattingFn : this.formatNumber;
        this.easingFn = (this.options.easingFn) ?
            this.options.easingFn : this.easeOutExpo;
        this.startVal = this.validateValue(this.options.startVal);
        this.frameVal = this.startVal;
        this.endVal = this.validateValue(endVal);
        this.options.decimalPlaces = Math.max(0 || this.options.decimalPlaces);
        this.decimalMult = Math.pow(10, this.options.decimalPlaces);
        this.resetDuration();
        this.options.separator = String(this.options.separator);
        this.useEasing = this.options.useEasing;
        if (this.options.separator === '') {
            this.options.useGrouping = false;
        }
        this.el = (typeof this.target === 'string') ? document.getElementById(this.target) : this.target;
        if (this.el) {
            this.printValue(this.startVal);
        }
        else {
            this.error = '[CountUp] target is null or undefined';
        }
    }
    // determines where easing starts and whether to count down or up
    determineDirectionAndSmartEasing() {
        const end = (this.finalEndVal) ? this.finalEndVal : this.endVal;
        this.countDown = (this.startVal > end);
        const animateAmount = end - this.startVal;
        if (Math.abs(animateAmount) > this.options.smartEasingThreshold) {
            this.finalEndVal = end;
            const up = (this.countDown) ? 1 : -1;
            this.endVal = end + (up * this.options.smartEasingAmount);
            this.duration = this.duration / 2;
        }
        else {
            this.endVal = end;
            this.finalEndVal = null;
        }
        if (this.finalEndVal) {
            this.useEasing = false;
        }
        else {
            this.useEasing = this.options.useEasing;
        }
    }
    // start animation
    start(callback) {
        if (this.error) {
            return;
        }
        this.callback = callback;
        if (this.duration > 0) {
            this.determineDirectionAndSmartEasing();
            this.paused = false;
            this.rAF = requestAnimationFrame(this.count);
        }
        else {
            this.printValue(this.endVal);
        }
    }
    // pause/resume animation
    pauseResume() {
        if (!this.paused) {
            cancelAnimationFrame(this.rAF);
        }
        else {
            this.startTime = null;
            this.duration = this.remaining;
            this.startVal = this.frameVal;
            this.determineDirectionAndSmartEasing();
            this.rAF = requestAnimationFrame(this.count);
        }
        this.paused = !this.paused;
    }
    // reset to startVal so animation can be run again
    reset() {
        cancelAnimationFrame(this.rAF);
        this.paused = true;
        this.resetDuration();
        this.startVal = this.validateValue(this.options.startVal);
        this.frameVal = this.startVal;
        this.printValue(this.startVal);
    }
    // pass a new endVal and start animation
    update(newEndVal) {
        cancelAnimationFrame(this.rAF);
        this.startTime = null;
        this.endVal = this.validateValue(newEndVal);
        if (this.endVal === this.frameVal) {
            return;
        }
        this.startVal = this.frameVal;
        if (!this.finalEndVal) {
            this.resetDuration();
        }
        this.determineDirectionAndSmartEasing();
        this.rAF = requestAnimationFrame(this.count);
    }
    printValue(val) {
        const result = this.formattingFn(val);
        if (this.el.tagName === 'INPUT') {
            const input = this.el;
            input.value = result;
        }
        else if (this.el.tagName === 'text' || this.el.tagName === 'tspan') {
            this.el.textContent = result;
        }
        else {
            this.el.innerHTML = result;
        }
    }
    ensureNumber(n) {
        return (typeof n === 'number' && !isNaN(n));
    }
    validateValue(value) {
        const newValue = Number(value);
        if (!this.ensureNumber(newValue)) {
            this.error = `[CountUp] invalid start or end value: ${value}`;
            return null;
        }
        else {
            return newValue;
        }
    }
    resetDuration() {
        this.startTime = null;
        this.duration = Number(this.options.duration) * 1000;
        this.remaining = this.duration;
    }
}

class CountUpDirective {
    // Re-animate if preference is set.
    // @HostListener('click')
    // private onClick(): void {
    //     if (this.reanimateOnClick) {
    //         this.animate();
    //     }
    // }
    constructor(el) {
        this.el = el;
        // Optional flag for specifying whether the element should re-animate when clicked.
        // Default is true.
        // @Input() private reanimateOnClick: boolean;
        // on-complete event emitter
        this.complete = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (changes.endVal && typeof changes.endVal.currentValue !== 'undefined') {
            this.countUp = this.createCountUp();
            this.animate();
        }
    }
    createCountUp() {
        const start = this.startVal || 0;
        const duration = this.duration || 2;
        const decimals = this.decimals || 0;
        const useGrouping = typeof this.useGrouping === 'undefined' ? true : this.useGrouping; // 3,000 (true) vs 3000 (false)
        if (!this.duration) {
            this.duration = duration;
        }
        this.options = {
            start,
            duration,
            decimals,
            useGrouping
        };
        // construct countUp
        let countUp = new CountUp(this.el.nativeElement, this.endVal, this.options);
        const diff = Math.abs(this.endVal - start);
        // make easing smoother for large numbers
        if (diff > 999) {
            const up = (this.endVal > start) ? -1 : 1;
            countUp = new CountUp(this.el.nativeElement, this.endVal + (up * 100), this.options);
        }
        return countUp;
    }
    animate() {
        this.countUp.reset();
        this.countUp.start(() => this.countUp.update(this.endVal));
        setTimeout(() => {
            this.complete.emit();
        }, this.duration * 1000);
    }
}
CountUpDirective.ɵfac = function CountUpDirective_Factory(t) { return new (t || CountUpDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CountUpDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CountUpDirective, selectors: [["", "appCountUp", ""]], inputs: { duration: "duration", startVal: "startVal", endVal: "endVal", decimals: "decimals", useGrouping: "useGrouping" }, outputs: { complete: "complete" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
CountUpDirective.ctorParameters = () => [
    { type: ElementRef }
];
CountUpDirective.propDecorators = {
    startVal: [{ type: Input }],
    endVal: [{ type: Input }],
    duration: [{ type: Input }],
    decimals: [{ type: Input }],
    useGrouping: [{ type: Input }],
    complete: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CountUpDirective, [{
        type: Directive,
        args: [{
                selector: '[appCountUp]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { complete: [{
            type: Output
        }], duration: [{
            type: Input
        }], startVal: [{
            type: Input
        }], endVal: [{
            type: Input
        }], decimals: [{
            type: Input
        }], useGrouping: [{
            type: Input
        }] }); })();

class CountUpModule {
}
CountUpModule.ɵfac = function CountUpModule_Factory(t) { return new (t || CountUpModule)(); };
CountUpModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CountUpModule });
CountUpModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CountUpModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [CountUpDirective],
                exports: [CountUpDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CountUpModule, { declarations: [CountUpDirective], exports: [CountUpDirective] }); })();

/*
 * Public API Surface of ng-count-up-js
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CountUpDirective, CountUpModule };

